import RcTree from '@rc-component/tree';
import type { BasicDataNode } from '@rc-component/tree';
import { PlusSquareIcon, EmptySquareIcon, MinusSquareIcon } from '@vlabs/icons';
import classNames from 'classnames';

import './Tree.sass';
import type { TreeNodeProps, TreeProps } from './types';

const TREE_PREFIX = 'custom-tree';

function TreeSwitcherIcon<TreeDataType extends BasicDataNode = BasicDataNode>({
  expanded,
  isLeaf,
}: TreeNodeProps<TreeDataType>): React.JSX.Element {
  const className = classNames(
    'Tree__SwitcherIcon',
    { Tree__SwitcherIcon_leaf: isLeaf },
  );

  if (isLeaf) {
    return <EmptySquareIcon className={className} />;
  }

  return expanded
    ? <MinusSquareIcon className={className} />
    : <PlusSquareIcon className={className} />;
}

function Tree<TreeDataType extends BasicDataNode = BasicDataNode>({
  className = undefined,
  switcherIcon = TreeSwitcherIcon,
  ...props
}: TreeProps<TreeDataType>): React.JSX.Element {
  return (
    <RcTree<TreeDataType>
      className={classNames('Tree', className)}
      prefixCls={TREE_PREFIX}
      switcherIcon={switcherIcon}
      {...props}
    />
  );
}

export { Tree, TreeSwitcherIcon };
